import * as React from "react";
import { toast } from "react-toastify";

export const V1ReportsNotSupported = () => {
	return (
		<span>
			V1 ExceleRATE Reports are no longer supported. Please contact{" "}
			<a href="mailto:support@impirica.tech">Impirica Support</a>
		</span>
	);
};

/** V1 (HTML-to-PDF) report generation was retired; tell the user who to call. */
export const notifyV1ReportsNotSupported = () => {
	toast.error(<V1ReportsNotSupported />, { autoClose: false });
};
